export const LoanTypeOption = [
  {
    laonTypeLabel: "Unsecured",
    laonTypeValue: "Unsecured",
  },
  {
    laonTypeLabel: "Secured",
    laonTypeValue: "Secured",
  },
];

export const CategoryOption = [
  {
    categoryTypeLabel: "Director's Club",
    categoryTypeValue: "Director's Club",
  },
  {
    categoryTypeLabel: "Other's Announcement",
    categoryTypeValue: "Other's Announcement",
  },
];

const hostname = window.location.hostname;
let tempLoginUrl, tempGAId;

if (hostname === "central-admin.sarvagram.com"){
  tempLoginUrl = "https://auth.sarvagram.com";
  tempGAId = 'G-W92X9JZ09N'
}else if (hostname === "uat-central-admin.sarvagram.net"){
  tempLoginUrl = "https://uat-login.sarvagram.net";
  tempGAId = 'G-CGDW75HE8G';
}else {
  tempLoginUrl = "https://dev-login.sarvagram.net";
  tempGAId = 'G-CGDW75HE8G';
}

export const loginUrl = tempLoginUrl;
export const gaId = tempGAId;

export const CDN_BASE_URL = "https://sarvagram-cdn.s3.ap-south-1.amazonaws.com";

// KeyClock URL for login services
let tempKeyClockUrl;
if (hostname === "central-admin.sarvagram.com") {
  tempKeyClockUrl = "https://gateway.sarvagram.com";
} else if (hostname === "uat-central-admin.sarvagram.net") {
  tempKeyClockUrl = "https://uat-api.sarvagram.net";
} else {
  tempKeyClockUrl = "https://dev-api.sarvagram.net";
}

export const keyClockUrl = tempKeyClockUrl;
